module.exports = __webpack_public_path__ + "img/ipad.e1a94693.svg";